<template>
  <output-dialog
    :pages="pages"
    filename="輸入諸掛費用明細(納入先別).pdf"
    orientation="portrait"
    ref="printDlg"
    title="輸入諸掛費用明細(納入先別)"
  >
    <template slot-scope="{ page }">
      <div class="page">
        <div style="text-align: right">
          発行日: &nbsp; &nbsp; &nbsp;
          {{ page.shipment.doConfirmDate }}
        </div>
        <h1>輸入諸掛費用明細(納入先別)</h1>
        <table v-if="page.pageIndex === 1">
          <tr>
            <td class="subTitle">D/O番号</td>
            <td>{{ page.shipment.doNo }}-{{ page.shipment.branchCode }}</td>
            <td colspan="2">シャープジャスダロジスティクス株式会社</td>
          </tr>
          <tr>
            <td class="subTitle">輸出者</td>
            <td>{{ page.shipment.partnerName }}</td>
            <td class="subTitle">(外線)TEL</td>
            <td>072-282-6094</td>
          </tr>
          <tr>
            <td class="subTitle">建値条件</td>
            <td>{{ page.shipment.incotermCode }}</td>
            <td class="subTitle">(外線)FAX</td>
            <td>072-282-1580</td>
          </tr>
          <tr>
            <td class="subTitle">B/L No.(MAWB)</td>
            <td>{{ page.shipment.masterBlNo }}</td>
            <td class="subTitle">(内線)TEL</td>
            <td></td>
          </tr>
          <tr>
            <td class="subTitle">B/L No.(HAWB)</td>
            <td>{{ page.shipment.houseBlNo }}</td>
            <td class="subTitle">(内線)FAX</td>
            <td></td>
          </tr>
          <tr>
            <td class="subTitle">積出日/積出港</td>
            <td>{{ page.shipment.etd }} {{ page.shipment.loadingPortName }}</td>
            <td class="subTitle">営業担当者</td>
            <td>{{ page.shipment.importSalesName }}</td>
          </tr>
          <tr>
            <td class="subTitle">本船入港日/到着港</td>
            <td>
              {{ page.shipment.eta }} {{ page.shipment.dischargePortName }}
            </td>
            <td class="subTitle">通関担当者</td>
            <td>{{ page.shipment.customsDirectorName }}</td>
          </tr>

          <tr>
            <td class="subTitle">納入場所名</td>
            <td>{{ page.shipment.sjlWarehouseName }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="subTitle">納入場所担当者名</td>
            <td>
              {{ page.shipment.finallyWarehouseManager1 }},{{
                page.shipment.finallyWarehouseManager2
              }}
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="subTitle">納入場所TEL</td>
            <td></td>
            <td class="subTitle">通関予定</td>
            <td></td>
          </tr>
          <tr>
            <td class="subTitle">納入日</td>
            <td>{{ page.shipment.forecastDeliveryDate }}</td>
            <td class="subTitle">計上日</td>
            <td></td>
          </tr>
        </table>

        <div class="summary" v-if="page.pageIndex === 1">
          <table>
            <tr class="header">
              <td style="width: 40%">項目</td>
              <td style="width: 20%; text-align: right">金額（税抜）</td>
              <td style="width: 20%; text-align: center">通貨</td>
              <td style="width: 20%; text-align: center">税区分</td>
            </tr>
            <tr
              :key="idx"
              v-for="(item, idx) in page.shipment.summaryCharges.filter(
                (c) =>
                  'AIR-008,SEA-011,AIR-010,SEA-013,LOCAL-010'.indexOf(
                    c.chargeItemCode
                  ) === -1
              )"
            >
              <td>{{ item.chargeItemName }}</td>
              <td style="text-align: right">
                {{
                  item.subTotal
                    | currency({
                      fractionCount: item.currencyCode === "JPY" ? 0 : 2,
                    })
                }}
              </td>
              <td style="text-align: center">{{ item.currencyCode }}</td>
              <td style="text-align: center">
                {{ hasTax(item) ? "課税" : "免税" }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px"></td>
              <td style="text-align: right">外貨課税合計</td>
              <td style="text-align: right">
                {{
                  totalHasTax(page.shipment) | currency({ fractionCount: 2 })
                }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px"></td>
              <td style="text-align: right">円価課税合計</td>
              <td style="text-align: right">
                {{
                  jpyTotalHasTax(page.shipment) | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px"></td>
              <td style="text-align: right">外貨免税合計</td>
              <td style="text-align: right">
                {{ totalNoTax(page.shipment) | currency({ fractionCount: 2 }) }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 0px"></td>
              <td style="text-align: right">円価免税合計</td>
              <td style="text-align: right">
                {{
                  jpyTotalNoTax(page.shipment) | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
          </table>
          <table style="width: 60%">
            <tr>
              <td style="width: 375.56px">商品代金（参考）</td>
              <td style="text-align: right">
                JPY
                {{
                  goodsTotalPrice(page.shipment)
                    | currency({ fractionCount: 0 })
                }}
              </td>
            </tr>
            <tr>
              <td>保険費（参考）</td>
              <td style="text-align: right"></td>
            </tr>
          </table>
        </div>
        <table
          style="width: 100%; table-layout: fixed"
          v-if="page.pageIndex === 1"
        >
          <tr
            :key="index"
            v-for="(charge, index) in chargesForComment(page.shipment)"
          >
            <td style="width: 250px">{{ charge.chargeItemName }} コメント</td>
            <td style="overflow-x: hidden; text-overflow: ellipsis">
              {{ charge.comment }}
            </td>
          </tr>
        </table>
        <table class="bill">
          <tr class="header">
            <td>
              伝票区分
              <br />検収区分
            </td>
            <td>SJL納品書/請求書</td>
            <td>P/O番号</td>
            <td>部品/機種コード</td>
            <td style="text-align: right">
              数量
              <br />外貨名
            </td>
            <td style="text-align: right">
              売上単価
              <br />外貨単価
            </td>
            <td style="text-align: right">
              売上金額
              <br />外貨額
            </td>
          </tr>
          <tr v-if="page.pageIndex === 1">
            <td colspan="7">
              コンテナー No.:
              {{
                page.shipment.packages.length > 0
                  ? page.shipment.packages[0].containerNo
                  : ""
              }}
            </td>
          </tr>
          <tr :key="idx" v-for="(item, idx) in page.items">
            <td colspan="7" v-if="item.isInvoice">
              <div style="display: flex; width: 100%">
                <div style="width: 200px">
                  INV No.: {{ item.eiaj.invoiceNo }}
                </div>
                <div style="width: 200px">
                  INV DATE: {{ item.eiaj.invoiceDate }}
                </div>
                <div style="width: 200px">P/C:{{ item.eiaj.productCode }}</div>
                <div style="width: 200px">
                  品種名: {{ item.eiaj.productName }}
                </div>
              </div>
            </td>
            <template v-else>
              <td>
                <div>EIAJ</div>
                <div>SAP</div>
              </td>
              <td v-if="item.eiaj.poOrderNo">{{ item.eiaj.no }}</td>
              <td v-if="!item.eiaj.poOrderNo">
                {{ page.shipment.invoiceSeqNo }}
              </td>
              <td>{{ item.eiaj.poOrderNo }}</td>
              <td>{{ item.eiaj.skuCode }}</td>
              <td style="text-align: right">
                <div>{{ item.eiaj.quantity }}</div>
                <div>({{ page.shipment.currencyCode }})</div>
              </td>
              <td style="text-align: right">
                <div>{{ item.eiaj.unitPrice }}</div>
                <div>{{ item.eiaj.unitPrice }}</div>
              </td>
              <td style="text-align: right">
                <div>
                  {{
                    Math.round(item.eiaj.quantity * item.eiaj.unitPrice * 100) /
                    100
                  }}
                </div>
                <div>
                  {{
                    Math.round(item.eiaj.quantity * item.eiaj.unitPrice * 100) /
                    100
                  }}
                </div>
              </td>
            </template>
          </tr>
        </table>
        <div class="footer">
          PAGE: {{ page.pageIndex }} / {{ page.total.value }}
        </div>
      </div>
    </template>
  </output-dialog>
</template>
<script>
export default {
  data() {
    return {
      pages: [],
    };
  },
  computed: {},
  methods: {
    hasTax(item) {
      return item.consumptionTaxRate > 0;
    },
    totalHasTax(shipment) {
      return shipment.summaryCharges
        .filter((c) => this.hasTax(c) && c.currencyCode !== "JPY")
        .filter(
          (c) =>
            "AIR-008,SEA-011,AIR-010,SEA-013,LOCAL-010".indexOf(
              c.chargeItemCode
            ) === -1
        )
        .reduce((t, c) => t + c.subTotal, 0);
    },
    jpyTotalHasTax(shipment) {
      return shipment.summaryCharges
        .filter((c) => this.hasTax(c) && c.currencyCode === "JPY")
        .filter(
          (c) =>
            "AIR-008,SEA-011,AIR-010,SEA-013,LOCAL-010".indexOf(
              c.chargeItemCode
            ) === -1
        )
        .reduce((t, c) => t + c.jpySubTotal, 0);
    },
    totalNoTax(shipment) {
      return shipment.summaryCharges
        .filter((c) => !this.hasTax(c) && c.currencyCode !== "JPY")
        .filter(
          (c) =>
            "AIR-008,SEA-011,AIR-010,SEA-013,LOCAL-010".indexOf(
              c.chargeItemCode
            ) === -1
        )
        .reduce((t, c) => t + c.subTotal, 0);
    },
    jpyTotalNoTax(shipment) {
      return shipment.summaryCharges
        .filter((c) => !this.hasTax(c) && c.currencyCode === "JPY")
        .filter(
          (c) =>
            "AIR-008,SEA-011,AIR-010,SEA-013,LOCAL-010".indexOf(
              c.chargeItemCode
            ) === -1
        )
        .reduce((t, c) => t + c.jpySubTotal, 0);
    },
    goodsTotalPrice(shipment) {
      return shipment.summaryCharges
        .filter((c) => "AIR-008,SEA-011".indexOf(c.chargeItemCode) !== -1)
        .reduce((t, c) => t + c.jpySubTotal, 0);
    },
    totalInsurance(shipment) {
      return shipment.summaryCharges
        .filter(
          (c) => "AIR-010,SEA-013,LOCAL-010".indexOf(c.chargeItemCode) !== -1
        )
        .reduce((t, c) => t + c.jpySubTotal, 0);
    },
    chargeWithCodes(shipment, codes) {
      return codes
        .map((code) => shipment.charges.find((c) => c.chargeItemCode === code))
        .filter((c) => c);
    },
    chargesForComment(shipment) {
      return this.chargeWithCodes(shipment, [
        "LOCAL-020",
        "LOCAL-021",
        "LOCAL-018",
        "LOCAL-019",
        "LOCAL-015",
        "LOCAL-016",
        "LOCAL-017",
        "LOCAL-012",
        "LOCAL-013",
        "LOCAL-014",
      ]);
    },
    popup(pages) {
      this.pages = [];
      this.$refs.printDlg.show = true;
      pages.forEach(this.splitPage);
    },
    splitPage(shipment) {
      /*mock*/
      // shipment.eiajs = []
      // for (let i = 0; i < 3; i++) {
      //   shipment.eiajs.push({})
      // }
      /*mock end*/
      let items = [];
      for (let i = 0; i < shipment.eiajs.length; i++) {
        items.push({ eiaj: shipment.eiajs[i], isInvoice: true });
        items.push({ eiaj: shipment.eiajs[i], isInvoice: false });
      }
      let pages = [];
      let total = { value: 0 };
      let page = {
        shipment: shipment,
        items: [],
        pageIndex: ++total.value,
        total: total,
      };
      pages.push(page);
      for (let i = 0; i < 2; i++) {
        let item = items.shift();
        if (!item) break;
        page.items.push(item);
      }
      while (items.length > 0) {
        page = {
          shipment: shipment,
          items: [],
          pageIndex: ++total.value,
          total: total,
        };
        pages.push(page);
        for (let i = 0; i < 36; i++) {
          let item = items.shift();
          if (!item) break;
          page.items.push(item);
        }
      }

      this.pages = [...this.pages, ...pages];
    },
  },
};
</script>
<style scoped>
.page {
  padding: 30px 30px;
  font-size: 12px;
}
h1 {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 2px 4px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}
table td {
  padding: 0px 2px;
  vertical-align: top;
}

.bill tr {
  border-bottom: 1px solid #333;
}
.bill .header {
  font-weight: bold;
}
.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 25px;
}

table .header {
  background: #d2d2d2;
  font-weight: bold;
}
.summary table td {
  border: 1px solid #333;
  padding: 0px 3px;
  font-size: 12px;
}

.subTitle {
  position: relative;
}
.subTitle::after {
  content: ":";
  position: absolute;
  right: 5px;
  top: 0px;
}
</style>

